import { render, staticRenderFns } from "./TextModule.vue?vue&type=template&id=672cfc3c&scoped=true&"
import script from "./TextModule.vue?vue&type=script&lang=js&"
export * from "./TextModule.vue?vue&type=script&lang=js&"
import style0 from "./TextModule.vue?vue&type=style&index=0&id=672cfc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cfc3c",
  null
  
)

export default component.exports